import { MailMenu } from '../gestioneerMenu';
import { componentsMenu, comptabiliteMenu, dashboardMenu, demoPages, layoutMenu } from '../menu';
import ChartsHeader from '../pages/common/Headers/ChartsHeader';
import ComponentsHeader from '../pages/common/Headers/ComponentsHeader';
import ContentHeader from '../pages/common/Headers/ContentHeader';
import DashboardBookingHeader from '../pages/common/Headers/DashboardBookingHeader';
import DashboardHeader from '../pages/common/Headers/DashboardHeader';
import DefaultHeader from '../pages/common/Headers/DefaultHeader';
import FormHeader from '../pages/common/Headers/FormHeader';
import IconHeader from '../pages/common/Headers/IconHeader';
import PageLayoutHeader from '../pages/common/Headers/PageLayoutHeader';
import ProductListHeader from '../pages/common/Headers/ProductListHeader';
import ProductsHeader from '../pages/common/Headers/ProductsHeader';
import ProfilePageHeader from '../pages/common/Headers/ProfilePageHeader';
import SummaryHeader from '../pages/common/Headers/SummaryHeader';
import UtilitiesHeader from '../pages/common/Headers/UtilitiesHeader';
import Header from '../pages/comptabilite/Header';

const headers = [
	{ path: MailMenu.acceptDevis.path + '/:id/:token', element: null, exact: true },
	{ path: MailMenu.paiement.path + '/:model/:id/:token', element: null, exact: true },
	{ path: MailMenu.confirmation.path, element: null, exact: true },

	{ path: layoutMenu.pageLayout.subMenu.onlySubheader.path, element: null, exact: true },
	{ path: layoutMenu.pageLayout.subMenu.onlyContent.path, element: null, exact: true },
	{ path: layoutMenu.blank.path, element: null, exact: true },
	{ path: demoPages.login.path, element: null, exact: true },
	{ path: demoPages.signUp.path, element: null, exact: true },
	{ path: demoPages.page404.path, element: null, exact: true },
	{ path: demoPages.knowledge.subMenu.grid.path, element: null, exact: true },
	{ path: '/pointVente/caisse/:id', element: null, exact: true },
	{ path: '/Pointage', element: null, exact: true },
	{ path: '/document-layouts/download/:model/:id', element: null, exact: true },

	// { path: dashboardMenu.dashboard.path, element: <DashboardHeader />, exact: true },

	{
		path: `*`,
		element: <DefaultHeader />,
	},

	{
		path: `${comptabiliteMenu.comptabilite.path}/*`,
		element: <Header />,
		exact: true,
	},
];

export default headers;
